function getURLVar(key) {
  var value = [];
  var query = String(document.location).split('?');
  if (query[1]) {
    var part = query[1].split('&');
    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');
      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }
    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }	
});

// Sidebar filter setup start
function replaceUrlParam(url, paramName, paramValue) {
  let pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  return url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue;
}

function filterCollParam(url, loader = true) {
  const wraperAjax = document.getElementById("wraper_ajax");
  loader && wraperAjax.classList.add("show");
  const moreBtn = document.querySelector("#more .button.btn-cart");
  if (moreBtn) {
    moreBtn.classList.add("loading");
  }
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseText) => {
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(responseText, "text/html");

      if (loader) {
        updateElementContent(responseDoc, "#custom-products", "custom-products");
      } else {
        updateElementContent(responseDoc, "#custom-products", "custom-products", true); // for loadmore pagination
      }
      updateElementContent(responseDoc, "#toolbar-products", "toolbar-products");
      updateElementContent(responseDoc, "#column-left", "column-left");
      updateElementContent(responseDoc, "#pagination", "pagination");
      //updateElementContent(responseDoc, "#top_filter_bar", "top_filter_bar");
      //updateElementContent(responseDoc, "#side_filter_bar", "side_filter_bar");
      //updateElementContent(responseDoc, "#active-filters", "active-filters");
      //updateElementContent(responseDoc, "#collection-amount", "collection-amount");

      const moreBtn = document.querySelector("#more .button.btn-cart");
      if (moreBtn) {
        moreBtn.classList.remove("loading");
      }

      handleLocalStorageView();

      history.pushState({ page: url }, url, url);

      loader && wraperAjax.classList.remove("show");

      if(window.SPR) {
      SPR?.registerCallbacks();
      SPR?.initRatingHandler();
      SPR?.initDomEls();
      SPR?.loadProducts();
      SPR?.loadBadges();
      }
      initSlider();

      // Handle Wishlist
      

      //filterAttributeHandler();
    })
    .catch((error) => {
      console.error("Fetch error: ", error);
      loader && wraperAjax.classList.remove("show");
      const moreBtn = document.querySelector("#more .button.btn-cart");
      if (moreBtn) {
        moreBtn.classList.remove("loading");
      }
    });
}

function updateElementContent(responseDoc, sourceSelector, targetId, isPagination = false) {
  const source = responseDoc.querySelector(sourceSelector);
  const target = document.getElementById(targetId);
  if (source && source.innerHTML.trim() && target) {
    if (isPagination) {
      target.innerHTML += source.innerHTML;
    } else {
      target.innerHTML = source.innerHTML;
    }
  }
}

function updateInnerHtml(selector, sourceDoc) {
  const targetElement = document.querySelector(selector);
  if (targetElement && sourceDoc.querySelector(selector)) {
    targetElement.innerHTML = sourceDoc.querySelector(selector).innerHTML;
  }
}

function handleLocalStorageView() {
  const typeElement = document.getElementById("category-view-type");
  const colsElement = document.getElementById("category-grid-cols");
  if (typeElement && colsElement) {
    const defaultType = typeElement.value;
    const cols = colsElement.value;
    let storedType = localStorage.getItem("type");

    if (storedType !== "grid" && storedType !== "list") {
      storedType = null;
    }

    if (!storedType) {
      if (cols) {
        if (defaultType === "list") {
          category_view.initView(defaultType, cols, "btn-list");
          //category_view.customPriceBoxList();
        } else if (defaultType === "grid") {
          category_view.initView(defaultType, cols, "btn-grid-" + cols);
          //category_view.customPriceBoxGrid();
        }
      }
    } else {
      const element = localStorage.getItem("element");
      const storedCols = localStorage.getItem("cols");
      category_view.initView(storedType, storedCols, element);
    }
  }
}
// Sidebar filter setup end
// resize code for equal size grids and content start
var img_ratio = 0.0/0.0;
var mass = {
  'resizeGrid': function(section,rows){
    // Equal height grid divs 
    var gridwidth = $(section+' .owl-carousel .owl-item').width();
    $(section+' .owl-carousel .owl-item .item .item-inner .image img').css("height",(gridwidth/img_ratio));
    //var gridwidth = $(section+' .owl-carousel .owl-item').width();
    var gridwidth1 = gridwidth/3.08;
    $(section+'.ocbestsellerproducts .owl-carousel .owl-item .item .item-inner .image img').css("height",(gridwidth1/img_ratio));

    if(rows > 1) {                  
      var gridheight = -1;
      
      $(section+' .owl-carousel .owl-item .item .item-inner .caption').each(function() {
        gridheight = gridheight > $(this).height() ? gridheight : $(this).height();
      });
      $(section+' .owl-carousel .owl-item .item .item-inner .caption').each(function() {
        $(this).height(gridheight);
      });
      
    }
  },
  'equalDivs': function(){
    // for equal height grid divs 
    if ($(window).width() <= 478 ) {
      var gridheight = -1;

      $('.custom-category .col-xs-6 .item .item-inner .caption').each(function() {
        gridheight = gridheight > $(this).height() ? gridheight : $(this).height();
      });

      $('.custom-category .col-xs-6 .item .item-inner .caption').each(function() {
        $(this).height(gridheight - 0);
      });
    }
    // blog page equal height grid divs 
    if ($(window).width() >= 479 ) {
      var gridheight = -1;

      $('.blog-blog .article-list.grid').each(function() {
        gridheight = gridheight > $(this).height() ? gridheight : $(this).height();
      });

      $('.blog-blog .article-list.grid').each(function() {
        $(this).height(gridheight + 10);
      });
    }
  },
  'resizeInsta': function(){
    // Instagram equal height grid divs 
    var gridheight;
    gridheight = $('#instagram_block_home1 .owl-carousel img').width();
    $('#instagram_block_home1 .owl-carousel img').css("height",gridheight);
  },
  'resizethumbs':function(){   
    // product page slideshow thumbs 
    var thumbwidth = $('.additional-images.owl-carousel .owl-stage .owl-item').width();
    $('.additional-images.owl-carousel .owl-item img').css("height",(thumbwidth/img_ratio));
  },
  'resizeRecentGrid':function(){   
    // product page slideshow thumbs 
    var thumbwidth = $('#recently-viewed-products.owl-carousel .owl-stage .owl-item').width();
    $('#recently-viewed-products.owl-carousel .owl-item img').css("height",(thumbwidth/img_ratio));
  }
}

// resize code for equal size grids and content end

$(window).resize(function() {
  setTimeout(function(){
    mass.equalDivs();
    mass.resizeInsta();
    mass.resizeRecentGrid();
  },200);
});



$(document).ready(function() {

  $('.shopify-currency-form select').on('change', function() {
    $(this)
    .parents('form')
    .submit();
  });

  mass.equalDivs();
  mass.resizeInsta();
  

  // sidebar mobile toggle code start 
  if ($(window).width() <=991 ) {

    $('#sidebar-toggle .oc-menu-bar').click(function (e) {
      e.stopPropagation();
      var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('#column-left').addClass('sidebar-toggle');
      $('.sidebar-overlay').toggle();
      if(effect == "none") {
        $('#column-left').toggle();
      }

      if(effect == "fade") {
        $('#column-left').fadeToggle();
      }

      if(effect == "slide") {
        $('#column-left').slideToggle();
      }

    });

    $('#column-left').click(function(e){
      e.stopPropagation();
    });

    $(document.body).click(function(e){
      var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('.sidebar-overlay').hide();
      if(effect == "none") {
        $('#column-left').hide();
      }
      if(effect == "fade") {
        $('#column-left').fadeOut();
      }
      if(effect == "slide") {
        $('#column-left').slideUp();
      }
    });
  }
  // sidebar mobile toggle code end

  // Adding active class for mobtabs on mobile layout
  $('.mobtab a').click(function(e){
    $('.mobtab a').removeClass('active');
    $(this).addClass('active');
  });

  // product video 
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  $('.popup-video').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click.
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // Listen for the close event
$(document).on('mfpClose', function () {
  // For iframe (YouTube, Vimeo, Google Maps), reset the src attribute
  $('.mfp-iframe').each(function() {
      var $iframe = $(this);
      var src = $iframe.attr('src');
      $iframe.attr('src', '').attr('src', src);
  });

  $('.popup-video').find('video').each(function() {
    this.pause(); // Pause the video
    this.currentTime = 0; // Optionally, rewind to start
});
  // // For inline videos, if they are HTML5 video tags, pause them
  // $('.mfp-inline-holder').find('video').each(function() {
  //     this.pause(); // Pause the video
  //     this.currentTime = 0; // Optionally, rewind to start
  // });

  // $('.mfp-hide').find('video').each(function() {
  //     this.pause(); // Pause the video
  //     this.currentTime = 0; // Optionally, rewind to start
  // });
});

  
  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        
        $.getJSON('/cart.js', function(cart) {
          load(cart);
        });
        
        
        	window.top.location.href="/cart";
        

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-sticky').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy_sticky select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-sticky').button('loading');
      },
      complete: function() {
        $('#button-cart-sticky').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

		
        	window.top.location.href="/cart";
        
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Item variant already added to the cart.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-buy').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-buy').button('loading');
      },
      complete: function() {
        $('#button-cart-buy').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          window.top.location.href="/checkout";
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning("Item variant already added to the cart.");
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  //stickyMenu();
  // var sticky_menu = $('#sticky-menu').attr('data-sticky');
  // if (sticky_menu==1){
  //   var headerSpaceH = 0;
  //   if ($(".common-home").length == 0){  
  //     if ($(".hd3").length == 0) {
  //       headerSpaceH = $('header .header-inner').outerHeight(true);
  //     }
  //   } else {
  //     headerSpaceH = $('header').outerHeight(true) + $('header').offset().top;
  //   }
  //   $('header').before('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');	
  // }

  // Scroll
  var currentP = 0;
  var stickyOffset1 = 0;
  var stickyOffset = 0;
  var modernMobileSticky = $('header.header-modern .header-modern__layer.fix');
  if (!isEmpty($('header'))) {
    stickyOffset = $('header').offset().top;
    stickyOffset += $('header').outerHeight();
    stickyOffset += 30;
    if (modernMobileSticky.length) {
      stickyOffset = modernMobileSticky.offset().top + 10;
    }
  }

  if (!isEmpty($('#product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }

  $(window).scroll(function(){
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();
    var winInnW = window.innerWidth;

    if(scrollP != currentP){
      //Sticky header
      var enableModernMobileSticky = $('header.header-modern .header-modern__layer.fix').length > 0;
      if( winInnW > 991 || enableModernMobileSticky ){
        //Sticky header
        //if (sticky_menu==1){
          if(scrollP >= stickyOffset){
            $('.fix').addClass('fix-header');
            // $('.headerSpace').removeClass('unvisible');
            // if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
            //   if (($(".bottom-menu").length == 0)) {
            //     $('.headerSpace').addClass('show');
            //   }
            // }
          } else {
            $('.fix').removeClass('fix-header');
            $('.headerSpace').addClass('unvisible');
            // if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
            //   if (($(".bottom-menu").length == 0)) {
            //     $('.headerSpace').removeClass('show');
            //   }
            // }
          }
        //}
      }
      if (!isEmpty($('#product-product'))) {

        if(scrollP >= stickyOffset1){
          $('.form_buy_sticky').addClass('fix-header2');
          $('.form_buy_sticky').addClass('fix-header1');
          // $('html').css('padding-bottom','64px');
        } else {
          $('.form_buy_sticky').removeClass('fix-header1');
          $('.form_buy_sticky').removeClass('fix-header2');
          // $('html').css('padding-bottom','0px');
        } 
      }
      currentP = $(window).scrollTop();
    }
  });

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  // move breadcrumbs
  $("header").after('<div class="breadcrumbs"><div class="container"><div class="inner"></div></div></div>');	
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  var breadcrumbs_container_inner = $('.breadcrumbs .container .inner');
  var breadcrumbs = $('.breadcrumbs');
  var page_title = $('#content > h1');
  var category_image = $('.category-image');

  breadcrumb.prependTo(breadcrumbs_container_inner);

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  $('#btn-search-category').click(function () {
    var url = '/search';
    var value = $('header #search-by-category input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search-by-category input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }
    location = url;
  });

  $('#text-search').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#btn-search-category').trigger('click');
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();
    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());
    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  $('#list-view').click(function() {
    $('#content .product-grid > .clearfix').remove();

    $('#content .row > .product-grid').attr('class', 'product-layout product-list col-xs-12 product-item');
    $('#grid-view').removeClass('active');
    $('#list-view').addClass('active');

    $(".product-item .item").each(function() {
      var caption_top = $(this).find('.caption-top');
      var caption_inner = $(this).find('.caption >.inner');
      $(this).find('.price-box').appendTo(caption_top);
      $(this).find('.btn-cart').appendTo(caption_top);
      $(this).find('.action-links').appendTo(caption_top);
      $(this).find('.product-name').prependTo(caption_inner);
    });

    localStorage.setItem('display', 'list');

  });

  // Product Grid
  $('#grid-view').click(function() {
    var cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item');
    } else if (cols == 1) {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-4 col-md-4 col-sm-6 col-xs-6 product-item');
    } else {
      $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-3 col-md-3 col-sm-6 col-xs-6 product-item');
    }

    $('#list-view').removeClass('active');
    $('#grid-view').addClass('active');

    $(".product-item .item").each(function() {
      var images_container = $(this).find('.images-container');
      var caption_top = $(this).find('.caption-top');
      var caption_inner = $(this).find('.caption >.inner');
      $(this).find('.action-links').appendTo(images_container);
      $(this).find('.price-box').appendTo(caption_inner);
      $(this).find('.btn-cart').appendTo(caption_inner);
      $(this).find('.product-name').prependTo(caption_top);
    });


    localStorage.setItem('display', 'grid');

  });

  if (localStorage.getItem('display') == 'list') {
    $('#list-view').trigger('click');
    $('#list-view').addClass('active');
  } else {
    $('#grid-view').trigger('click');
    $('#grid-view').addClass('active');
  }

  // grid-style

  $('.grid-style .item').mouseover(function() {
    $(this).closest('.grid-style').addClass('active');
  });
  $('.grid-style .item').mouseout(function() {
    $(this).closest('.grid-style').removeClass('active');
  });
  // Checkout
    $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
      if (e.keyCode == 13) {
        $('#collapse-checkout-option #button-login').trigger('click');
      }
    });
    // tooltips on hover
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
    // Makes tooltips work on ajax generated content
    $(document).ajaxStop(function() {
      $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
    });
  });

  var cart = {
    'add': function(product_id, quantity,redirect) {
      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
        dataType: 'json',
        beforeSend: function() {
          var btn = $(this);
          if(redirect) {
            $('.button-cart.button').button('loading');
          } else {
            $('.button-cart > .button').button('loading');
          }

        },
        complete: function() {
          if(redirect) {
            $('.button-cart.button').button('reset');
          } else {
            //        $('.btn-cart').button('reset');

            $('.button-cart > .button').button('reset');
          }
        },
        success: function(json) {
          $('.alert, .text-danger').remove();

          if (json['redirect']) {
            location = json['redirect'];
          }

        $.getJSON('/cart.js', function(cart) {
            if(redirect) {
              window.top.location.href="/checkout";
            }
          
          window.top.location.href="/cart";
          
          });
        },
        error: function(xhr, ajaxOptions, thrownError) {
          if(xhr.status == 422 ) {
            toastr.warning("Item variant already added to the cart.");
                           } else {
                           alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
          }
        }
      });
    },
    'remove': function(key) {
      $.ajax({
        url: '/cart/update.js',
        type: 'post',
        data: 'updates['+key+']=0',
        dataType: 'json',
        beforeSend: function() {
          //$('#cart > button').button('loading');
        },
        success: function(json) {
          $('#cart > button').button('reset');
          if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
            location = '/cart';
          } else {
            setTimeout(function () {
              load(json);
            }, 5);       
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          alert(xhr.responseText);
        }
      });
    }
  }

  function load(cart){
    $('#cart .dropdown-menu > li:first-child .table > tbody > tr').remove();
    var bundles = {};
    var bundleOrder = [];
    var baseCount = 0;
    var countedBundles = {};

    $.each(cart.items, function (index, cartItem) {
      var buildId = cartItem.properties && cartItem.properties._ts_build_id;
      if (!buildId) {
        baseCount += cartItem.quantity || 0;
        var line = index + 1;
        var cents = "";

        if (cartItem.price % 100 < 10) {
          cents = "0";
        }
        var price = parseInt(cartItem.price / 100) + "." + cents + cartItem.price % 100;

        var cartRemove = 'onclick="cart.remove(\''+cartItem.id+'\')"';
        var itemRow = "<tr><td class='text-center'><a href='" + cartItem.url + "' title='" + cartItem.title + "'><img class='cart-image' src='" + cartItem.image + "' alt='" + cartItem.title + "' title='" + cartItem.title + "'></a></td><td class='text-left info-item'><a class='cart-name' href='" + cartItem.url + "'>" + cartItem.title + "</a><p class='cart-quantity'>" + cartItem.quantity + " &times; &nbsp;</p><p class='cart-price'><span class='money'>" + Shopify.formatMoney(price, moneyFormat) + "</span></p></td><td class='text-center cart-close'><button type='button' "+cartRemove+"' title='Remove' class='btn btn-danger btn-xs'><i class='icon-delete'></i></button></td></tr>";
        $('#cart .dropdown-menu > li:first-child .table > tbody').append(itemRow);
        return;
      }

      if (!bundles[buildId]) {
        bundles[buildId] = {
          items: [],
          parent: null,
          total: 0,
          keys: []
        };
        bundleOrder.push(buildId);
      }

      var bundle = bundles[buildId];
      bundle.items.push(cartItem);
      bundle.keys.push(cartItem.key);
      var lineTotal = cartItem.final_line_price || cartItem.line_price || 0;
      bundle.total += lineTotal;
      if (cartItem.properties && (cartItem.properties._ts_bundle_role === 'parent' || cartItem.properties._ts_role === 'base')) {
        bundle.parent = cartItem;
      }
    });

    $.each(bundleOrder, function (index, buildId) {
      var bundle = bundles[buildId];
      if (!bundle || !bundle.items.length) {
        return;
      }
      if (!bundle.parent) {
        bundle.parent = bundle.items[0];
      }

      if (!countedBundles[buildId]) {
        baseCount += bundle.parent.quantity || 0;
        countedBundles[buildId] = true;
      }

      var parent = bundle.parent;
      var title = (parent.properties && parent.properties._ts_bundle_title) || parent.product_title || parent.title;
      var image = parent.image || '';
      var url = parent.url || '#';
      var qty = parent.quantity || 0;
      var totalPrice = Shopify.formatMoney(bundle.total, moneyFormat);
      var addonsHtml = '';
      $.each(bundle.items, function (idx, bundleItem) {
        if (bundleItem === parent) {
          return;
        }
        if (bundleItem.properties && (bundleItem.properties._ts_bundle_role === 'parent' || bundleItem.properties._ts_role === 'base')) {
          return;
        }
        var addonLabel = (bundleItem.properties && bundleItem.properties._ts_bundle_label) || bundleItem.variant_title || bundleItem.title;
        var addonPrice = Shopify.formatMoney(bundleItem.final_line_price || bundleItem.line_price || 0, moneyFormat);
        addonsHtml += "<div class='ts-bundle__addon'><span class='ts-bundle__addon-label'>" + addonLabel + "</span><span class='ts-bundle__addon-price'><span class='money'>" + addonPrice + "</span></span></div>";
      });

      var keysString = bundle.keys.join('|');
      var bundleRow = "<tr class='ts-bundle ts-mini-bundle' data-bundle-keys='" + keysString + "'><td class='text-center'><a href='" + url + "' title='" + title + "'><img class='cart-image' src='" + image + "' alt='" + title + "' title='" + title + "'></a></td><td class='text-left info-item'><a class='cart-name' href='" + url + "'>" + title + "</a><div class='ts-mini-bundle__meta'><p class='cart-quantity'>" + qty + " &times; &nbsp;</p><p class='cart-price'><span class='money'>" + totalPrice + "</span></p></div><div class='ts-bundle__addons'>" + addonsHtml + "</div></td><td class='text-center cart-close'><button type='button' title='Remove' class='btn btn-danger btn-xs ts-bundle__remove' data-bundle-keys='" + keysString + "'><i class='icon-delete'></i></button></td></tr>";
      $('#cart .dropdown-menu > li:first-child .table > tbody').append(bundleRow);
    });
    if (cart.item_count < 1) {
      $('#cart .dropdown-menu > li:first-child .table > tbody').append('<p class="text-center cart-empty">Your shopping cart is empty!</p>');
                                                                       $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('show');
      $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('hide');
    } else {
      $('#cart .dropdown-menu p.cart-empty').remove();
      $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('hide');
      $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('show');
    }
    $('#cart > button #cart-total .txt_number').html(baseCount);
    $('#cart > button .total-price').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'<i class="fas fa-chevron-down"></i></span>');
    $('#cart-subtotal').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'</span>');
    
    if (Currency.cookie.read() != null) {
      Currency.convertAll(shopCurrency, Currency.cookie.read());
    }
    
  }

/* Vehicle lookup fallback: recovers dropdown/search if app block JS fails to initialize. */
(function () {
  function addOption(select, value, label) {
    var opt = document.createElement("option");
    opt.value = value;
    opt.textContent = label;
    select.appendChild(opt);
  }

  function fillSelect(select, values, placeholder) {
    if (!select) return;
    select.innerHTML = "";
    addOption(select, "", placeholder);
    (values || []).forEach(function (value) {
      if (value === null || value === undefined) return;
      var text = String(value).trim();
      if (!text) return;
      addOption(select, text, text);
    });
  }

  function setRow(root, name, show) {
    var row = root.querySelector('[data-field-row="' + name + '"]');
    if (!row) return;
    row.hidden = !show;
    row.style.display = show ? "" : "none";
  }

  function strictUrl(make, model, year) {
    var params = new URLSearchParams();
    params.set("vl_mode", "strict_fitment");
    params.set("vl_make", make);
    params.set("vl_model", model);
    params.set("vl_year", year);
    return "/collections/all?" + params.toString();
  }

  function repairWidget(root) {
    if (!root || root.dataset.vlFallbackBound === "1") return;

    var makeSelect = root.querySelector('select[name="make"]');
    var modelSelect = root.querySelector('select[name="model"]');
    var yearSelect = root.querySelector('select[name="yearOfManufacture"]');
    var engineSelect = root.querySelector('select[name="engineCapacity"]');
    var searchButton = root.querySelector("[data-vehicle-search]");
    var status = root.querySelector("[data-status]");

    if (!makeSelect || !modelSelect || !yearSelect || !searchButton) return;
    if (makeSelect.options.length > 1) return;

    root.dataset.vlFallbackBound = "1";

    var endpoint = root.getAttribute("data-endpoint") || "/apps/vehicle-lookup";
    var url = new URL(endpoint, window.location.origin);
    url.searchParams.set("mode", "dataset");

    fetch(url.toString(), { method: "GET" })
      .then(function (response) {
        return response.json().catch(function () { return {}; });
      })
      .then(function (payload) {
        var data = payload && payload.data && typeof payload.data === "object" ? payload.data : {};
        var makes = Object.keys(data).sort(function (a, b) { return a.localeCompare(b); });
        if (!makes.length) return;

        setRow(root, "make", true);
        setRow(root, "model", false);
        setRow(root, "yearOfManufacture", false);
        setRow(root, "engineCapacity", false);

        fillSelect(makeSelect, makes, "Select make");
        fillSelect(modelSelect, [], "Select model");
        fillSelect(yearSelect, [], "Select year");
        fillSelect(engineSelect, [], "Select engine");

        function getEntry() {
          var mk = makeSelect.value;
          var mdl = modelSelect.value;
          if (!mk || !mdl || !data[mk] || !data[mk][mdl]) return null;
          return data[mk][mdl];
        }

        function onMake() {
          var mk = makeSelect.value;
          var models = mk && data[mk] ? Object.keys(data[mk]).sort(function (a, b) { return a.localeCompare(b); }) : [];
          fillSelect(modelSelect, models, "Select model");
          fillSelect(yearSelect, [], "Select year");
          fillSelect(engineSelect, [], "Select engine");
          setRow(root, "model", Boolean(mk));
          setRow(root, "yearOfManufacture", false);
          setRow(root, "engineCapacity", false);
          if (status) status.textContent = "";
        }

        function onModel() {
          var entry = getEntry();
          var years = entry && Array.isArray(entry.years) ? entry.years : [];
          fillSelect(yearSelect, years, "Select year");
          fillSelect(engineSelect, [], "Select engine");
          setRow(root, "yearOfManufacture", Boolean(modelSelect.value));
          setRow(root, "engineCapacity", false);
          if (status) status.textContent = "";
        }

        function onYear() {
          var entry = getEntry();
          var year = yearSelect.value;
          var engines = [];
          if (entry && entry.enginesByYear && typeof entry.enginesByYear === "object") {
            if (year && Array.isArray(entry.enginesByYear[year])) {
              engines = entry.enginesByYear[year];
            } else if (Array.isArray(entry.enginesByYear.__all__)) {
              engines = entry.enginesByYear.__all__;
            }
          }
          fillSelect(engineSelect, engines, "Select engine");
          setRow(root, "engineCapacity", Boolean(year && engines.length));
          if (status) status.textContent = "";
        }

        makeSelect.addEventListener("change", onMake);
        modelSelect.addEventListener("change", onModel);
        yearSelect.addEventListener("change", onYear);

        searchButton.addEventListener("click", function () {
          var mk = String(makeSelect.value || "").trim();
          var mdl = String(modelSelect.value || "").trim();
          var yr = String(yearSelect.value || "").trim();
          if (!mk || !mdl || !yr) {
            if (status) status.textContent = "Please select make, model, and year.";
            return;
          }
          window.location.assign(strictUrl(mk, mdl, yr));
        });
      })
      .catch(function () {
        // ignore fallback fetch errors
      });
  }

  function runRepair() {
    var roots = document.querySelectorAll(".ts-vehicle-lookup");
    if (!roots || !roots.length) return;
    for (var i = 0; i < roots.length; i += 1) {
      repairWidget(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runRepair);
  } else {
    runRepair();
  }
  window.setTimeout(runRepair, 1200);
})();

/* vl-strict-filter-fix: keep strict vehicle params on sidebar filtering and align availability facet with strict results */
(function () {
  function getStrictSelection() {
    var current = new URL(window.location.href);
    if (String(current.searchParams.get("vl_mode") || "").trim() !== "strict_fitment") {
      return null;
    }
    return {
      mode: "strict_fitment",
      make: String(current.searchParams.get("vl_make") || "").trim(),
      model: String(current.searchParams.get("vl_model") || "").trim(),
      year: String(current.searchParams.get("vl_year") || "").trim(),
    };
  }

  function strictAwareUrl(rawUrl) {
    var strict = getStrictSelection();
    if (!strict) return rawUrl;
    var target = new URL(rawUrl || window.location.pathname, window.location.origin);
    if (strict.mode) target.searchParams.set("vl_mode", strict.mode);
    if (strict.make) target.searchParams.set("vl_make", strict.make);
    if (strict.model) target.searchParams.set("vl_model", strict.model);
    if (strict.year) target.searchParams.set("vl_year", strict.year);
    return target.pathname + (target.search ? target.search : "");
  }

  if (typeof window.filterCollParam === "function" && !window.__vlStrictFilterCollParamWrapped) {
    var baseFilterCollParam = window.filterCollParam;
    window.filterCollParam = function (url, loader) {
      var strict = getStrictSelection();
      if (strict) {
        window.location.assign(strictAwareUrl(url));
        return;
      }
      return baseFilterCollParam(url, loader);
    };
    window.__vlStrictFilterCollParamWrapped = true;
  }

  function getStrictCards() {
    return Array.from(document.querySelectorAll("#custom-products .product-layout"));
  }

  function isSoldOutCard(card) {
    if (!card) return false;
    return Boolean(
      card.querySelector(".badge-soldout") ||
      card.querySelector(".label-product.label-sold-out") ||
      card.querySelector(".sold-out")
    );
  }

  function setCountText(selector, count) {
    var el = document.querySelector(selector);
    if (!el) return;
    el.textContent = "(" + String(count) + ")";
  }

  function updateStrictAvailabilityFacetCounts(allCards) {
    var inStock = 0;
    var outOfStock = 0;
    allCards.forEach(function (card) {
      if (isSoldOutCard(card)) {
        outOfStock += 1;
      } else {
        inStock += 1;
      }
    });

    var inOption = document.querySelector('input[name="filter.v.availability"][value="1"]');
    var outOption = document.querySelector('input[name="filter.v.availability"][value="0"]');
    if (inOption) {
      var inCount = inOption.closest(".filter-option") && inOption.closest(".filter-option").querySelector(".filter-option-count");
      if (inCount) inCount.textContent = "(" + String(inStock) + ")";
    }
    if (outOption) {
      var outCount = outOption.closest(".filter-option") && outOption.closest(".filter-option").querySelector(".filter-option-count");
      if (outCount) outCount.textContent = "(" + String(outOfStock) + ")";
    }
  }

  function updateStrictResultHeading(count) {
    var sidebarTitle = document.querySelector(".collection-sidebar-title");
    if (sidebarTitle) {
      sidebarTitle.textContent = String(count) + " Products";
    }

    var summary = document.getElementById("collection-amount");
    if (summary) {
      summary.textContent = "Showing 1 to " + String(count) + " of " + String(count) + " items";
    }
  }

  function applyStrictAvailabilityFromUrl() {
    var strict = getStrictSelection();
    if (!strict) return false;

    var current = new URL(window.location.href);
    var selected = current.searchParams.getAll("filter.v.availability");
    var cards = getStrictCards();
    if (!cards.length) return false;

    updateStrictAvailabilityFacetCounts(cards);

    var showInStockOnly = selected.length === 1 && selected[0] === "1";
    var showOutOfStockOnly = selected.length === 1 && selected[0] === "0";

    var visible = 0;
    cards.forEach(function (card) {
      var soldOut = isSoldOutCard(card);
      var keep = true;
      if (showInStockOnly) keep = !soldOut;
      if (showOutOfStockOnly) keep = soldOut;
      card.style.display = keep ? "" : "none";
      if (keep) visible += 1;
    });

    updateStrictResultHeading(visible);
    return true;
  }

  function scheduleStrictAvailabilityApply() {
    [0, 150, 500, 1200, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        applyStrictAvailabilityFromUrl();
      }, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleStrictAvailabilityApply);
  } else {
    scheduleStrictAvailabilityApply();
  }

  window.addEventListener("vehicle-lookup:update", function () {
    scheduleStrictAvailabilityApply();
  });
})();

/* vl-strict-prime: prevent initial flash of non-strict collection products */
(function () {
  function isStrictModeUrl() {
    var current = new URL(window.location.href);
    return String(current.searchParams.get("vl_mode") || "").trim() === "strict_fitment";
  }

  function primeStrictGrid() {
    if (!isStrictModeUrl()) return;

    var grid = document.getElementById("custom-products");
    // A completed app response must survive late DOMContentLoaded handlers.
    if (grid && grid.querySelector('.vehicle-lookup-strict-card, .vehicle-lookup__strict-empty')) {
      grid.dataset.vlStrictPrimed = "1";
      return;
    }
    if (grid && grid.dataset.vlStrictPrimed !== "1") {
      grid.dataset.vlStrictPrimed = "1";
      grid.innerHTML = '<div class="vehicle-lookup__strict-loading" style="padding:16px;">Loading matching products...</div>';
    }

    var sidebarTitle = document.querySelector(".collection-sidebar-title");
    if (sidebarTitle) {
      sidebarTitle.textContent = "Loading products...";
    }

    var summary = document.getElementById("collection-amount");
    if (summary) {
      summary.textContent = "Loading matching products...";
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", primeStrictGrid);
  } else {
    primeStrictGrid();
  }
})();
